/**
 * Devis decision engine — shared shapes (#1585).
 *
 * OBSERVE-ONLY. Nothing in here shares, validates or declines a quote; the
 * engine produces a stored recommendation and a SUPER_ADMIN reads it. The
 * automatic decision itself is #1586.
 *
 * The WEIGHTS and the `problematic` penalty deliberately do NOT live here —
 * they belong to one constants file on the backend
 * (`apps/api/src/domains/quotes/decision/quote-decision.constants.ts`). Every
 * stored breakdown carries the weight it was scored with, so a consumer never
 * needs to know the current numbers to render an old row.
 */
/**
 * Stage A. A veto is binary and is never traded off against a high score: the
 * quote falls back to a human. Owner ruling 2026-08-25 — exactly three, and
 * `problematic` is NOT one of them (see {@link QuoteDecisionBlocker}).
 */
export var QuoteDecisionVeto;
(function (QuoteDecisionVeto) {
    /** The technician carries an active `blacklisted` flag. */
    QuoteDecisionVeto["BLACKLISTED_TECHNICIAN"] = "blacklisted_technician";
    /** `total_ht` exceeds `organizations.intervention_trigger_limit`. */
    QuoteDecisionVeto["ABOVE_TRIGGER_LIMIT"] = "above_trigger_limit";
    /** The quote is a revision (`version > 1` or `parent_quote_id` set). */
    QuoteDecisionVeto["QUOTE_IS_REVISION"] = "quote_is_revision";
})(QuoteDecisionVeto || (QuoteDecisionVeto = {}));
/** Stage B criteria. Weights are owned by the backend constants file. */
export var QuoteDecisionCriterion;
(function (QuoteDecisionCriterion) {
    QuoteDecisionCriterion["RELATIVE_PRICE"] = "relative_price";
    QuoteDecisionCriterion["MARGIN"] = "margin";
    QuoteDecisionCriterion["RELIABILITY"] = "reliability";
    QuoteDecisionCriterion["PROXIMITY"] = "proximity";
    QuoteDecisionCriterion["RESPONSIVENESS"] = "responsiveness";
    QuoteDecisionCriterion["EXCLUSIVITY_B2B"] = "exclusivity_b2b";
})(QuoteDecisionCriterion || (QuoteDecisionCriterion = {}));
/**
 * Why a quote that survived Stage A still may not be decided automatically.
 * These are NOT vetoes: the quote is scored and ranked normally, it just needs
 * a human to press the button.
 */
export var QuoteDecisionBlocker;
(function (QuoteDecisionBlocker) {
    /** At least one Stage A veto fired. */
    QuoteDecisionBlocker["VETOED"] = "vetoed";
    /**
     * The technician is flagged `problematic` AND another technician has a
     * PENDING quote on the same intervention. Flagged and alone is the
     * deliberate "last resort" and stays auto-decidable.
     */
    QuoteDecisionBlocker["PROBLEMATIC_WITH_COMPETITION"] = "problematic_with_competition";
})(QuoteDecisionBlocker || (QuoteDecisionBlocker = {}));
